(function () {
  'use strict';

  angular
      .module('tfc.retailer.DashboardDescription')
      .factory('DashboardDescriptionModal',DashboardDescriptionModal)
      .directive('tfcDashboardDescription', tfcDashboardDescription);

  // @ngInject
  function DashboardDescriptionModal($uibModal) {

    return {
      showModal : showModal
    };

    function showModal(selectedBrand, dashboardType, isActivity, isRegion, selectedActivity) {
      var modalInstance = $uibModal.open({
        size: 'sm',
        templateUrl: 'Util/DashboardDescription/DashboardDescriptionModal.tmpl.html',
        controller: function ($scope) {
          var vm = $scope;
          vm.isActivity = isActivity;
          vm.isRegion = isRegion;
          vm.selectedActivity = selectedActivity;
          vm.i18nDashboardType = "reports." + dashboardType + ".subtitle";
          vm.i18nFilterType = "reports." + dashboardType + ((vm.isActivity) ? ".activity" : "") + ((vm.isRegion) ? ".region" : "") + ".subtitle";
          vm.selectedBrand = selectedBrand;
          vm.cancel = function () {
            modalInstance.close();
          }
        }
      });
    }

  }

  function tfcDashboardDescription(DashboardDescriptionModal) {
    return {
      restrict: 'E',
      templateUrl : 'Util/DashboardDescription/DashboardDescription.tmpl.html',
      scope : {
        selectedBrand : '=brand',
        dashboardType: '@type',
        isActivity: "=",
        isRegion: "=",
        selectedActivity:"="
      },
      transclude: true,
      link : function (scope,element,attrs) {
        var vm = scope;
        var isClickable = angular.isDefined(attrs.isClickable) && vm.$eval(attrs.isClickable) === true ? true : false;

        if (isClickable) {
          attrs.$set('ngClick', 'openDashboardDescriptionModal()');
          element.removeAttr('ng-transclude');
          $compile(element)(vm);
        }

        vm.openDashboardDescriptionModal = function() {
          DashboardDescriptionModal.showModal(scope.selectedBrand,scope.dashboardType,scope.isActivity,scope.isRegion,scope.selectedActivity);
        }
      }
    };
  }

})();